import { combineReducers } from 'redux';

import {
  SELECTED_VENUE_OWNERSHIP_CHANGED,
  VENUE_OWNERSHIP_UPDATED,
  SEATING_SETTINGS_UPDATED,
  CUSTOM_FIELDS_CHANGED
} from '../constants/ticketingSettingsConstants';

const csrfToken = (state = "", action) => {
  switch (action.type) {
    default:
      return state;
  }
};

const team = (state = {}, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

const currentUser = (state = {}, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

const seatingSettings = (state = {}, action) => {
  switch (action.type) {
    case SEATING_SETTINGS_UPDATED:
      return {
        ...state,
        [action.venueOwnershipId]: action.seatingData
      };
    default:
      return state;
  }
};

const withClientCustomFields = (venueOwnership, current) => ({
  ...venueOwnership,
  custom_fields: current.custom_fields || venueOwnership.custom_fields,
});

const venueOwnerships = (state = [], action) => {
  switch (action.type) {
    case VENUE_OWNERSHIP_UPDATED:
      return [...state].map((vo) => {
        if(vo.id === action.venueOwnership.id){
          return withClientCustomFields(action.venueOwnership, vo);
        } else {
          return vo;
        }
      })
    case CUSTOM_FIELDS_CHANGED:
      return state.map((vo) => (
        vo.id === action.venueOwnershipId ? { ...vo, custom_fields: action.customFields } : vo
      ));
    default:
      return state;
  }
};

const selectedVenueOwnership = (state = {}, action) => {
  switch (action.type) {
    case SELECTED_VENUE_OWNERSHIP_CHANGED:
      return action.venueOwnership;
    case VENUE_OWNERSHIP_UPDATED:
      if (action.venueOwnership.id !== state.id) return state;
      return Object.assign({}, withClientCustomFields(action.venueOwnership, state), {
        ticket_confirmation_info: state.ticket_confirmation_info,
      });
    case CUSTOM_FIELDS_CHANGED:
      if (action.venueOwnershipId !== state.id) return state;
      return { ...state, custom_fields: action.customFields };
    default:
      return state;
  }
};

const maxDescriptorLength = (state = 0, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

const eventOrderFormAvailable = (state = false) => state;

const ticketingSettingsReducer = combineReducers({
  csrfToken,
  team,
  currentUser,
  seatingSettings,
  venueOwnerships,
  selectedVenueOwnership,
  maxDescriptorLength,
  eventOrderFormAvailable
});

export default ticketingSettingsReducer;
